/* NewEden2.0 — cart-drawer.js
   Cart logic: add-to-cart (PDP + quick-add), drawer fetch/render,
   quantity change, line removal, free-shipping progress bar. */
(function () {
  'use strict';
  var NE = window.NewEden || {};
  var routes = NE.routes || {};

  function getSectionsToRender() {
    return ['cart-drawer'];
  }

  function cartAdd(items) {
    var body = { items: items, sections: getSectionsToRender(), sections_url: window.location.pathname };
    return fetch(routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function cartChange(payload) {
    payload.sections = getSectionsToRender();
    payload.sections_url = window.location.pathname;
    return fetch(routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); });
  }

  function getCart() {
    return fetch(routes.cart_url + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  /* ---- render helpers ---- */
  function replaceSection(id, html) {
    var target = document.getElementById(id);
    if (!target || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var source = doc.getElementById(id);
    if (source) target.innerHTML = source.innerHTML;
  }

  function applyCartSections(cart) {
    if (!cart || !cart.sections) return;
    if (cart.sections['cart-drawer']) replaceSection('cart-drawer-content', cart.sections['cart-drawer']);
    if (cart.sections['cart-icon-bubble']) replaceSection('cart-icon-bubble', cart.sections['cart-icon-bubble']);
    updateBubbleCount(cart.item_count);
    updateFreeShipping();
    NE.emit && NE.emit(NE.PUB.cartUpdate, cart);
  }

  function updateBubbleCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', !count);
    });
  }

  function updateFreeShipping() {
    var threshold = (NE.cart && NE.cart.freeShippingThreshold) || 0;
    document.querySelectorAll('[data-free-shipping]').forEach(function (wrap) {
      if (!threshold) { wrap.hidden = true; return; }
      var total = parseInt(wrap.getAttribute('data-gross-total'), 10) || 0;
      var bar = wrap.querySelector('[data-free-shipping-bar]');
      var msg = wrap.querySelector('[data-free-shipping-msg]');
      var remaining = threshold - total;
      var pct = Math.min(100, Math.round((total / threshold) * 100));
      if (bar) bar.style.width = pct + '%';
      if (msg) {
        if (remaining <= 0) {
          msg.innerHTML = wrap.getAttribute('data-msg-success') || (NE.strings && NE.strings.freeShippingSuccess) || 'Free shipping unlocked!';
          wrap.classList.add('is-complete');
        } else {
          var tmpl = wrap.getAttribute('data-msg-progress') || (NE.strings && NE.strings.freeShippingProgress) || '[amount] away from free shipping';
          var amountHtml = '<strong>' + NE.formatMoney(remaining) + '</strong>';
          msg.innerHTML = tmpl
            .replace('[amount]', amountHtml)
            .replace(/\{\{\s*amount\s*\}\}/, amountHtml);
          wrap.classList.remove('is-complete');
        }
      }
    });
  }

  /* ---- add to cart ---- */
  function setLoading(btn, on) {
    if (!btn) return;
    btn.classList.toggle('is-loading', on);
    btn.disabled = on;
    var label = btn.querySelector('[data-add-label]');
    var spin = btn.querySelector('[data-loading]');
    if (label) label.classList.toggle('hidden', on);
    if (spin) spin.classList.toggle('hidden', !on);
  }

  function showError(form, message) {
    var box = form && form.parentElement.querySelector('[data-form-error]');
    if (box) { box.hidden = false; box.textContent = message; }
    else alert(message);
  }

  // <product-form> submit
  if (!customElements.get('product-form')) {
    customElements.define('product-form', class extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        if (this.form) this.form.addEventListener('submit', this.onSubmit.bind(this));
      }
      onSubmit(e) {
        e.preventDefault();
        var btn = this.querySelector('[data-add-to-cart]');
        if (btn && btn.getAttribute('aria-disabled') === 'true') return;
        setLoading(btn, true);
        var fd = new FormData(this.form);
        var items = [{ id: fd.get('id'), quantity: parseInt(fd.get('quantity') || '1', 10) }];
        var props = {};
        fd.forEach(function (v, k) {
          var m = k.match(/properties\[(.+)\]/);
          if (m) props[m[1]] = v;
        });
        if (Object.keys(props).length) items[0].properties = props;
        cartAdd(items)
          .then((res) => {
            if (res.status) { showError(this.form, res.description || res.message); return; }
            applyCartSections(res);
            NE.openDrawer && NE.openDrawer('cart');
          })
          .catch(() => showError(this.form, 'Etwas ist schief gelaufen. Bitte erneut versuchen.'))
          .finally(() => setLoading(btn, false));
      }
    });
  }

  // <product-quick-add> single-variant button
  if (!customElements.get('product-quick-add')) {
    customElements.define('product-quick-add', class extends HTMLElement {
      constructor() {
        super();
        this.btn = this.querySelector('button');
        if (this.btn) this.btn.addEventListener('click', this.onClick.bind(this));
      }
      onClick() {
        var id = this.btn.getAttribute('data-variant-id');
        if (!id) return;
        this.btn.classList.add('is-loading');
        this.btn.disabled = true;
        cartAdd([{ id: id, quantity: 1 }])
          .then((res) => {
            if (res.status) return;
            applyCartSections(res);
            NE.openDrawer && NE.openDrawer('cart');
          })
          .finally(() => { this.btn.classList.remove('is-loading'); this.btn.disabled = false; });
      }
    });
  }

  /* ---- drawer + cart page line edits (event delegation) ---- */
  function changeLine(line, quantity) {
    document.body.classList.add('cart-loading');
    cartChange({ line: parseInt(line, 10), quantity: quantity })
      .then(function (cart) {
        applyCartSections(cart);
        /* The cart template is server-rendered; refresh it after a successful
           quantity change while keeping drawer changes fully Ajax-driven. */
        if (document.querySelector('.cart-page--conversion')) {
          window.location.reload();
        }
      })
      .finally(function () { document.body.classList.remove('cart-loading'); });
  }

  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-cart-item] .cart-item__remove, [data-line][data-remove]');
    if (remove && remove.hasAttribute('data-line')) {
      e.preventDefault();
      changeLine(remove.getAttribute('data-line'), 0);
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches('.quantity-selector__input')) return;
    var holder = input.closest('[data-line]');
    if (!holder) return;
    changeLine(holder.getAttribute('data-line'), parseInt(input.value, 10));
  });

  // Initialise free-shipping bar on load from current DOM totals if present
  document.addEventListener('DOMContentLoaded', function () {
    updateFreeShipping();
  });

  // Expose for other modules
  NE.cartAPI = { add: cartAdd, change: cartChange, get: getCart, render: applyCartSections };
})();
